import { useMutation } from '@apollo/client'
import { ApproveVaccination, ApproveVaccinationVariables } from '../../types'
import { APPROVE_VACCINATION } from './operations'

export const useApproveVaccination = () =>
  useMutation<ApproveVaccination, ApproveVaccinationVariables>(APPROVE_VACCINATION)
